import { Injectable } from '@angular/core';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
import { Coordinates, Geolocation, Geoposition } from '@awesome-cordova-plugins/geolocation/ngx';
import { LocationAccuracy } from '@awesome-cordova-plugins/location-accuracy/ngx';
import { NativeGeocoder, NativeGeocoderOptions, NativeGeocoderResult } from '@awesome-cordova-plugins/native-geocoder/ngx';
import { AlertController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, timer } from 'rxjs';
import { ChiaveConfig } from '../models/configurazioni/ChiaveConfig';
import { AuthService } from './auth-service/auth-service';
import { ConfigService } from './config-service/config-service';
import { PlatformName } from './env-service/env-platform';
import { EventsService } from './eventsService';
import { UserService } from './user-service';

declare var google: any;

@Injectable({
  providedIn: 'root'
})
export class GeolocUtilityService {

  refreshSubscription: Subscription;
  // const timeout = this.envService.GEOLOC_TIMEOUT;
  timeout = 16000;
  subscriptionCancelled = false;
  coords: Coordinates;
  geolocactive = false;
  userCity: any;
  latLngResult: any;
  userLocationFromLatLng: NativeGeocoderResult;
  // zone: any;

  constructor( private locationAccuracy: LocationAccuracy,
               private platform: Platform,
               private translateService: TranslateService,
               private userService: UserService,
               private alertCtrl: AlertController,
               private diagnostic: Diagnostic,
               private geolocation: Geolocation,
               private authService: AuthService,
               private nativeGeocoder: NativeGeocoder,
               private configService: ConfigService,
               private events: EventsService
 
               ) {
  }

  async checkGPSPermission() {
    console.log('checkGPSPermission PlatformName', PlatformName );
    if (this.platform.is(PlatformName) && (!this.authService.isAuthExpired()) ) { // ex cordova

      /**
       * NOTE:
       * 1. Check if location permission is already granted and enabled for app to use
       * 2. If not, show alert requesting location permission from user.
       */
    await this.diagnostic.isLocationAuthorized().then(async authorized => {
      console.log('Location is ' + (authorized ? 'authorized' :   'unauthorized'));
       if (!authorized) {
          console.log('location is unauthorized, richiede autorizzazione ');
          await this.requestLocationAuth();
       } else {
          // location is authorized
          console.log('location is authorized, richiede attivazione del GPS ');
          await this.askToTurnOnGPS();
       }
      }).catch(err => {
        console.log('isLocationAuthorized', err);
        // in ios va in errore, vediamo se così funziona
        this.requestLocationAuth();
      });
    }
  }


  async requestLocationAuth() {
    console.log('requestLocationAuth start');
    await this.diagnostic.requestLocationAuthorization().then(async (status) => {
      let label = '';
      console.log('status ' + status);
      switch (status) {
      case this.diagnostic.permissionStatus.NOT_REQUESTED:
          console.log('Permission not requested');
          break;
      case this.diagnostic.permissionStatus.GRANTED:
          console.log('Permission granted, richedere la posizione');
          await this.askToTurnOnGPS();
          break;
      case this.diagnostic.permissionStatus.DENIED_ONCE:
          console.log('Permission denied, si avvisa che dovrà riavviare per concedere i grant');
          // Show alert if user doesn't grant permission
          label = 'gps-utility-service.notgranted.' + this.userService.getUserType() ;
          await this.showalert( this.translateService.instant( label ));
          break;
      case this.diagnostic.permissionStatus.DENIED_ALWAYS:
        console.log('Permission permanently denied, si avvisa che dovrà andare a dare esplicitamente il grant o reinstallare');
        label = 'gps-utility-service.notgrantedpermanent.' + this.userService.getUserType() ;
        await this.showalert( this.translateService.instant( label ));
        break;
      /*case this.diagnostic.permissionStatus.GRANTED_WHEN_IN_USE:
        console.log('status GRANTED_WHEN_IN_USE');
        this.askToTurnOnGPS();
        break;
      case this.diagnostic.permissionStatus.RESTRICTED:
        console.log('status RESTRICTED');
        this.askToTurnOnGPS();
        break;
      case this.diagnostic.permissionStatus.DENIED:
        console.log('status DENIED');
        this.askToTurnOnGPS();
        break;*/
      default:
        console.log('requestLocationAuth status', status);
        // this.askToTurnOnGPS();
        break;
        }
    }).catch(error => {
    console.log('requestLocationAuth error', error);
  });


  }

  async askToTurnOnGPS() {
    await this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
      () => {
        // When GPS Turned ON call method to get Accurate location coordinates
            console.log('GPS abilitato');
            this.geolocactive = true;
      },
      async error => {
              this.geolocactive = false;
              // Show alert if user click on 'No Thanks'
              const label = 'gps-utility-service.info.' + this.userService.getUserType() ;
              await this.showalert( this.translateService.instant( label ));

      }
    );
  }

    async showalert( message: string ) {
       (await this.alertCtrl.create({
        header: 'Attenzione',
        message: message,
        buttons: ['OK']
      }))
      .present();
    }

    getCoordinateDefault(callback) {
        const geocoder = new google.maps.Geocoder();
        let coordinateDefault: any;

        // utilizza il par conf con le cordinate di default
        const initcoords = this.configService.getConfigurazione(ChiaveConfig.DEFAULT_GEOLOC_COORDS);
        if (initcoords) {
          const lat_ = initcoords.split(',')[0];
          const lat: number = +lat_;
          const lng_ = initcoords.split(',')[1];
          const lng: number = +lng_;
          if (lat !== 0) {
            coordinateDefault = { lat: lat, lng: lng };
            console.log( 'coordinateDefault da config' , coordinateDefault );
          }
        }

          // se non è presente il par conf con le coordinate iniziali utilizza l'indirizzo di default
          if (!coordinateDefault) {
          const address = this.configService.getConfigurazione(ChiaveConfig.DEFAULT_GEOLOCALIZZAZIONE);
          console.log( 'geodecoding default address: ', address );
          geocoder.geocode({'address': address}, (results, status) => {
              console.log( 'geodecoding staus ' + status );
              if (status === 'OK') {
                const lat = results[0].geometry.location.lat();
                const lng = results[0].geometry.location.lng();
                // coordinateIniziali = results[0].geometry.location;
                coordinateDefault = { lat: lat, lng: lng };
                console.log( 'coordinateDefault ' , coordinateDefault );
              } else {
                alert('Geocode was not successful for the following reason: ' + status);
              }
            });
        }
        // se tutto va male ... ibiza
        if (!coordinateDefault) {
          coordinateDefault = { lat: 38.9627135, lng: 1.2185169 }; // people from ibiza
        }
        callback( coordinateDefault );
    }

    async isGeolocActive() {
      // let geolocactive = false;
      const options = {
        enableHighAccuracy: true,
        timeout: 15000 // this.envService.GEOLOC_TIMEOUT,
      };
      console.log('isGeolocActive before getCurrentPosition');
      // this.geolocactive = false;
      try {
        const geopos: Geoposition = await this.geolocation.getCurrentPosition(options);
        if ( geopos ) {
          this.coords = geopos.coords;
          this.geolocactive = true;
        } else {
          this.geolocactive = false;
          this.coords = null;
        }
      } catch (error) {
        console.log('isga' , error);
        this.geolocactive = false;
        this.coords = null;
      }
      // await this.geolocation.getCurrentPosition(options).then(
      //   coords => {
      //     this.geolocactive = true;
      //     console.log('coords', coords);
      //   },
      //   error => {
      //     this.geolocactive = false;
      //     console.log('err', error);
      //   }
      // );
      console.log('isGeolocActive after getCurrentPosition');
      // return geolocactive;
    }

    async checkGeoLocStatus() {
      console.log('checkGeoLocStatus this.subscriptionCancelled', this.subscriptionCancelled);
      this.isSubscriptionCancelled().then(async cancelled => {
        if (!cancelled) {
          console.log('checkGeoLocStatus before check', this.geolocactive);
          await this.isGeolocActive().then(() => {
            this.isSubscriptionCancelled().then(async cancelled2 => {
              if ( !cancelled2 ) {
                this.geolocactive = this.geolocactive;
                this.events.geolocIsActive.next({ geolocactive: this.geolocactive , coords: this.coords} );
              }
            });
            console.log('checkGeoLocStatus after check', this.geolocactive);
          });
        }
      });
    }
    turnGeolocCheckOn() {
      console.log('turnGeolocCheckOn');
      this.refreshSubscription = timer(0, this.timeout).subscribe(() => {
        this.checkGeoLocStatus();
        this.subscriptionCancelled = false;
      });
    }
    async turnGeolocCheckOff() {
      console.log('turnGeolocCheckOff');
      this.cancelSubscription().then(async () => {
        console.log('turnGeolocCheckOff subscriptionCancelled', this.subscriptionCancelled);
        if (this.refreshSubscription) {
          await this.refreshSubscription.unsubscribe();
        }
      });
    }
    async isSubscriptionCancelled() {
      return this.subscriptionCancelled;
    }
    async cancelSubscription() {
      this.subscriptionCancelled = true;
    }

    // questa implementazione non funziona correttamante in cordova
    // cercare di comprenderne il motivo
   async getAddress(lat: number, lng: number, callback) {
      if (this.platform.is(PlatformName)) {
        await this.getAddressMobile(lat, lng, callback).then((address) => {
          callback(address);
        });
      } else {
        await this.getAddressBrowser(lat, lng, callback).then((address) => {
          callback(address);
        });
      }
    }

    async getAddressBrowser(lat: number, lng: number, callback) {
      if (navigator.geolocation) {
        const geocoder = new google.maps.Geocoder();
        const latlng = new google.maps.LatLng(lat, lng);
        const request = { latLng: latlng };

        try {
          await geocoder.geocode(request, (results, status) => {
            let address;
            console.log('getAddressBrowser status ', status );
            if (status === google.maps.GeocoderStatus.OK) {
              const result = results[0];
              if (result != null) {
                  address = result.formatted_address;
                  console.log('getAddressBrowser richiamo la callback con address ', address );
                  callback(address);
              }
            }
            if (!address) {
              callback( this.translateService.instant( 'gps-utility-service.addressnotloaded' ) );
            }
          });
        } catch (error) {
          console.log('getAddressBrowser error', error );
        }
      }
    }

    async getAddressMobile(lat: number, lng: number, callback) {
      if (this.platform.is(PlatformName)) {
        const options: NativeGeocoderOptions = {
          useLocale: true,
          maxResults: 1
        };
        await this.nativeGeocoder.reverseGeocode(lat, lng, options)
          .then((result: NativeGeocoderResult[]) => {
                            this.userLocationFromLatLng = result[0];
                            console.log( 'indirizzo', this.userLocationFromLatLng );
                      })
          .catch((error: any) => console.log(error));

        await callback( this.formattedAddress(this.userLocationFromLatLng)) ;
      }
    }

    formattedAddress(address): string {
      let formattedAddress = '';
      if (address) {
          formattedAddress =
            `${address.thoroughfare}, ${address.subThoroughfare}, ${address.postalCode}, ${address.locality}, ${address.countryName}`;
      }
      return formattedAddress;
    }

    computeDistanceBetween (latitude1: any, longitude1: any, latitude2: any, longitude2: any) {
      const marker1 = new google.maps.Marker({
        position: { lat: latitude1, lng: longitude1 }
      });
      const marker2 = new google.maps.Marker({
        position: { lat: latitude2, lng: longitude2 }
      });
      return this.haversine_distance(marker1, marker2) ;

    }
    haversine_distance(mk1, mk2) {
      // const R = 3958.8; // Radius of the Earth in miles
      // const R = 6371.0710; // Radius of the Earth in km
      const R = 6371071; // Radius of the Earth in meters

      const rlat1 = mk1.position.lat() * (Math.PI / 180); // Convert degrees to radians
      const rlat2 = mk2.position.lat() * (Math.PI / 180); // Convert degrees to radians
      const difflat = rlat2 - rlat1; // Radian difference (latitudes)
      const difflon = (mk2.position.lng() - mk1.position.lng()) * (Math.PI / 180); // Radian difference (longitudes)

      const d = 2 * R * Math.asin(Math.sqrt(Math.sin(difflat / 2) * Math.sin(difflat / 2) +
                        Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2)));
      return Math.round(d); //
    }
  }
